import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import styles from './chat-not-found.module.scss';

const ChatNotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={clsx(styles.chatNotFound)}>
      <h1 className="vc-heading-A48">{t('CHAT.DISCUSSIONS.NO_MESSAGES_TITLE')}</h1>
      <p className="vc-heading-A24">{`${t('CHAT.DISCUSSIONS.NO_MESSAGES_SUBTITLE')}`}</p>
    </div>
  );
};

export default ChatNotFound;
